import { api, setToken } from "./client";

export async function register(username: string, password: string) {
  await api("/register", "POST", { username, password }, false);
}

export async function login(username: string, password: string) {
  const data = await api<{ token: string }>("/login", "POST", { username, password }, false);
  setToken(data.token);
}
